import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_MOEIN = "getMoein";
export const GET_COMPRATIVE = "getComparative";


// mutation types
export const SET_MOEIN = "setMoein";
export const SET_COMPRATIVE = "setComparative";



export default {
    state: {
        
        moein:[],
        comparative:[],
      
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
       
        loadedComparative(state) {
            return state.comparative;
        },
        loadedMoein(state) {
            return state.moein;
        },
       
    },
    actions: {
        /**
         * Set the comparative list
         * @param state
         * @param payload
         */
          [GET_COMPRATIVE](state, payload) {
            return new Promise((resolve, reject) => { httpHelper
                    .getData(payload)
                    .then((response) => {
                      
                        state.commit(SET_MOEIN, response);
                        resolve(response)
                    })
                    .catch((error) => {
                       
                    })
                    .finally(() => {});
                })
        },
         /**
         * Set the moein list 
         * @param state
         * @param payload
         */
           [GET_MOEIN](state, payload) {
            return new Promise((resolve, reject) => { httpHelper
                    .getData(payload)
                    .then((response) => {
                        
                        state.commit(SET_MOEIN, response);
                        resolve(response);
                    })
                    .catch((error) => {
                       
                    })
                    .finally(() => {});
                });
        },
    },
    mutations: {
        
        [SET_MOEIN](state, payload) {
            
            state.moein = payload;
            
        },
        [SET_COMPRATIVE](state, payload) {
            state.comparative = payload;
        },
        
       
    }
};